module.exports = __webpack_public_path__ + "static/img/bnf.ff0026f5.svg";